// src/components/FilterChips.tsx
import { memo } from 'react';
import '../styles/FilterChips.css';

interface FilterChipsProps {
  activeFilters: string[];
  onToggleFilter: (filter: string) => void;
  onClearAll: () => void;
  availableTags: string[];
}

const DIFFICULTY_FILTERS = ['Beginner', 'Intermediate', 'Advanced'];

export const FilterChips = memo(function FilterChips({
  activeFilters,
  onToggleFilter,
  onClearAll,
  availableTags,
}: FilterChipsProps) {
  const hasActiveFilters = activeFilters.length > 0;

  return (
    <div className="filter-chips" data-testid="filter-chips">
      {/* All / Clear button */}
      <button
        className={`filter-chip ${!hasActiveFilters ? 'active' : ''}`}
        onClick={onClearAll}
        data-testid="filter-all"
      >
        All
      </button>

      {/* Difficulty filters */}
      {DIFFICULTY_FILTERS.map((filter) => (
        <button
          key={filter}
          className={`filter-chip ${activeFilters.includes(filter) ? 'active' : ''}`}
          onClick={() => onToggleFilter(filter)}
          data-testid={`filter-${filter.toLowerCase()}`}
        >
          {filter}
        </button>
      ))}

      {/* Divider if tags exist */}
      {availableTags.length > 0 && <div className="filter-chips-divider" />}

      {/* Tag filters */}
      {availableTags.map((tag) => (
        <button
          key={tag}
          className={`filter-chip ${activeFilters.includes(tag) ? 'active' : ''}`}
          onClick={() => onToggleFilter(tag)}
          data-testid={`filter-tag-${tag.toLowerCase()}`}
        >
          {tag}
        </button>
      ))}
    </div>
  );
});
